import { render, staticRenderFns } from "./PillarPaginaDeVendasParaAfiliados.vue?vue&type=template&id=70e28e7a&"
import script from "./PillarPaginaDeVendasParaAfiliados.vue?vue&type=script&lang=js&"
export * from "./PillarPaginaDeVendasParaAfiliados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports